import {
  SET_CATEGORY_DATA,
  SET_MENU_ITEM_DATA,
  TOGGLE_IMAGE_MODAL,
  SET_IMAGE_DATA
} from './constants';

const initialState = {
  shop: null,
  items: null,
  modal: {},
  category: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORY_DATA:
      return {
        ...state,
        shop: action.payload
      };
    case SET_MENU_ITEM_DATA:
      return {
        ...state,
        items: action.payload
      };
    case TOGGLE_IMAGE_MODAL:
      return {
        ...state,
        modal: action.payload
      };
    case SET_IMAGE_DATA:
      return {
        ...state,
        modal: {},
        items: state.items.map((item) => {
          if (item.id === action.payload.id) {
            item.assetUrl = action.payload.url;
          }

          return item;
        })
      };
    default:
      return state;
  }
};

export default reducer;